// extracted by mini-css-extract-plugin
export var alert = "DepositLimits-module--alert--e703a";